import { CustomerAddresses } from '../api';

export const getLocationServiceAddress = (
    addresses: CustomerAddresses['addresses'] | undefined,
    locationId: number | undefined
) => {
    return addresses?.find(a => a.id === locationId)?.data;
};
